<template>
    <div
        v-loading="loading"
        class="user-portfolio-comments-item"
        :class="{ 'user-portfolio-comments-item--removed': removed }"
    >
        <div class="user-portfolio-comments-item__image">
            <img v-if="authorImage" :src="authorImage" alt="" />
            <img v-else src="~@/assets/images/account/placeHolder-m.png" alt="" />
        </div>
        <div class="user-portfolio-comments-item__content">
            <div class="user-portfolio-comments-item__title">
                <div
                    class="user-portfolio-comments-item__name"
                    :class="{
                        'user-portfolio-comments-item__name--current': isCurrentUser
                    }"
                >
                    {{ getName(comment) }}
                </div>
                <div class="user-portfolio-comments-item__date">{{ comment.timeString }}</div>
                <div
                    v-if="isCurrentUser"
                    class="user-portfolio-comments-item__actions"
                >
                    <span />
                    <div class="user-portfolio-comments-item__edit">
                        <div class="user-portfolio-comments-item__edit-button" @click="openEditField">Редактировать</div>
                        <div class="user-portfolio-comments-item__edit-button" @click="remove">Удалить</div>
                    </div>
                </div>
            </div>
            <div class="user-portfolio-comments-item__text">
                <div v-if="!editField" v-html="commentHtml"/>
                <template v-else>
                    <textarea ref="commentInput" v-model="commentText"></textarea>
                    <button
                        :disabled="commentText.length === 0"
                        @click="save"
                        class="button button-blue"
                        :class="{
                            'button-disabled': commentText.length === 0,
                        }"
                    >
                        Сохранить
                    </button>
                    <button @click="closeEditField" class="button button-red button-outline">Отмена</button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import { parseISO } from "date-fns";
import { format, utcToZonedTime } from "date-fns-tz";
import {highlightStrKeywords} from "@/tools/graphQueryHelpers";

export default {
    data: () => ({
        loading: false,
        editField: false,
        commentText: '',
        removed: false,
    }),

    props: {
        comment: Object,
        highlightKeywords: {
            type: Array,
            default: () => [],
        },
    },

    watch: {
        commentText() {
            this.updateFieldSize();
        },
    },

    computed: {
        ...mapGetters([
            'userProfileInfo',
        ]),
        ...mapGetters('newUsers', [
            'getUser',
        ]),

        isCurrentUser() {
            const comment = this.comment;
            const user = this.userProfileInfo;

            if (!user || !comment || !comment.author) {
                return false;
            }

            return comment.author.id === user.userId;
        },

        authorImage() {
            const user = this.comment.author;
            return user.avatar || user.avatarOfficial || null;
        },

        commentHtml() {
            const str = (this.comment.text || '').trim();

            console.log('comment', str, highlightStrKeywords(str, this.highlightKeywords).replaceAll(/\r\n|\r|\n/g, '<br>'));

            return str
                ? highlightStrKeywords(str, this.highlightKeywords).replaceAll(/\r\n|\r|\n/g, '<br>')
                : str
            ;
        },
    },

    methods: {
        ...mapActions('newUsers', [
            'updateUserComment',
            'removeUserComment',
        ]),

        getName(item) {
            console.log('user');
            return [
                item.author.surname,
                item.author.name,
                item.author.patronimic,
            ].filter(v => v).join(' ');
        },

        openEditField() {
            this.editField = true;
            this.commentText = this.comment.text;
            this.$nextTick(() => this.updateFieldSize());
        },

        closeEditField() {
            this.editField = false;
        },

        async save() {
            this.loading = true;

            await this.updateUserComment({ id: this.comment.id, text: this.commentText});

            this.$emit('change');
            this.editField = false;
            this.loading = false;
        },

        async remove() {
            this.loading = true;
            this.editField = false;
            await this.removeUserComment(this.comment.id);
            this.$emit('change');
            this.loading = false;
            this.removed = true;
        },

        updateFieldSize() {
            const textarea = this.$refs.commentInput;
            textarea.style.height = 'auto';
            textarea.style.height = `${textarea.scrollHeight}px`;
        },
    },
};

</script>

<style scoped lang="scss">
@import "~@/styles/rem";
@import '~@/styles/variables';
@import '~@/styles/buttons_v2';

.user-portfolio-comments-item {
    display: grid;
    grid-template-columns: mrem(40) auto;
    gap: mrem(16);

    @include on-desktop {
        grid-template-columns: rem(40) auto;
        gap: rem(16);
    }

    &--removed {
        opacity: 0.5;
        filter: grayscale(1);
    }

    &__image {
        img {
            width: 100%;
            object-fit: contain;
            border-radius: mrem(40);

            @include on-desktop {
                border-radius: rem(40);
            }
        }
    }

    &__content {
        display: flex;
        flex-direction: column;
        gap: mrem(3);

        @include on-desktop {
            gap: rem(3);
        }
    }
    &__title {
        display: grid;
        grid-template-columns: auto auto;
        gap: mrem(16);

        @include on-desktop {
            gap: 0;
            grid-template-columns: rem(210) rem(135) rem(24);
        }
    }
    &__name {
        font-weight: 600;

        @include on-mobile {
            grid-column-start: 1;
            grid-column-end: 4;
        }

        &--current {
            color: $color-main-blue;
        }
    }
    &__date {
        color: $color-main-grey;
        font-weight: 400;
        font-size: mrem(14);
        line-height: mrem(20);

        @include on-desktop {
            font-size: rem(14);
            line-height: rem(20);
            margin-left: rem(40);
        }
    }
    &__text {
        font-weight: 400;
        display: flex;
        flex-wrap: wrap;
        gap: mrem(16);

        @include on-desktop {
            gap: rem(16);
        }

        textarea {
            width: 100%;
            font: inherit;
            padding: 1em;
            resize: none;
            background: $color-main-notice-lighter;
            appearance: none;
            border: none;
            min-height: mrem(80);
            border-radius: mrem(16);

            @include on-desktop {
                min-height: rem(80);
                border-radius: rem(16);
            }
        }
    }

    &__actions {
        position: relative;

        span {
            display: inline-block;
            border: none;
            cursor: pointer;
            background: url("~@/assets/images/portfolio/dots.svg") no-repeat center center;
            background-size: contain;
            width: mrem(24);
            height: mrem(24);

            @include on-desktop {
                width: rem(24);
                height: rem(24);
            }

            &:hover {
                & + .user-portfolio-comments-item__edit {
                    display: inline-flex;
                }
            }
        }
    }
    &__edit {
        display: none;
        position: absolute;
        flex-direction: column;
        align-items: flex-start;
        border-radius: 16px;
        background: #FFF;
        box-shadow: 0 mrem(2) mrem(16) 0 rgba(70, 99, 171, 0.10);
        right: calc(100% - #{mrem(24)});
        top: mrem(20);
        padding: mrem(16);
        gap: mrem(16);

        @include on-desktop {
            box-shadow: 0 rem(2) rem(16) 0 rgba(70, 99, 171, 0.10);
            right: calc(100% - #{rem(24)});
            top: rem(20);
            padding: rem(16);
            gap: rem(16);
        }

        &:hover {
            display: inline-flex;
        }

        &-button {
            cursor: pointer;
            color: $color-secondary-dark_violet;
            font-weight: 500;
            font-size: mrem(14);
            line-height: mrem(20);

            @include on-desktop {
                font-size: rem(14);
                line-height: rem(20);
            }

            &:hover {
                color: $color-main-blue;
            }
        }
    }
}
</style>
